import { render, staticRenderFns } from "./distributeContent.vue?vue&type=template&id=00c4ca3e&scoped=true"
import script from "./distributeContent.vue?vue&type=script&lang=js"
export * from "./distributeContent.vue?vue&type=script&lang=js"
import style0 from "./distributeContent.vue?vue&type=style&index=0&id=00c4ca3e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c4ca3e",
  null
  
)

export default component.exports